module.exports = __webpack_public_path__ + "static/media/schody21 - schody drewniane lakierowane z podestem.e9b84947.jpg";